import { useState } from "react";
import { Button, Modal } from "react-bootstrap";

/**
 * Modal para la revisión de mitad de año donde el jefe puede:
 * - solicitar ajustes (type === 'reject') proporcionando un comentario y opcionalmente un plan de acción
 * - aprobar sin ajustes (type !== 'reject') también dejando un comentario opcional y opcionalmente un plan de acción
 *
 * Props:
 * - showFormModal: boolean -> controla la visibilidad del modal.
 * - setShowFormModal: function -> función para actualizar la visibilidad desde el padre.
 * - onSubmit: function -> callback que recibe (comment:string, includeActionPlan:boolean).
 * - type: string -> 'reject' para solicitar ajuste, otro valor para aprobar.
 */
const SecondPeriodRejectObjectivesModal = ({ showFormModal, setShowFormModal, onSubmit, type }) => {
    // Estado local que guarda el comentario de retroalimentación del jefe
    const [comment, setComment] = useState("");

    // Estado local que indica si se debe exigir un plan de acción junto con la solicitud
    const [includeActionPlan, setIncludeActionPlan] = useState(false);

    /**
     * Envía los datos al callback del padre y cierra el modal.
     */
    const handleReject = () => {
        onSubmit(comment, includeActionPlan);
        setShowFormModal(false);
    };

    return (
        <Modal
            show={showFormModal}
            onHide={() => setShowFormModal(false)}
            size="md"
            centered
        >
            <Modal.Header closeButton>
                {/* Título dinámico según el tipo de acción */}
                <Modal.Title className="ft-modal-title">
                    {type === 'reject' ? 'Solicitar Ajuste de Objetivos' : 'Aprobar Objetivos'}
                </Modal.Title>
            </Modal.Header>

            <Modal.Body>
                {/* Instrucción breve para el usuario */}
                <p>Proporcione un comentario de retroalimentación.</p>

                {/* Textarea controlada para recoger el comentario */}
                <textarea
                    rows={4}
                    className="form-control mt-3"
                    value={comment}
                    onChange={(e) => setComment(e.target.value)}
                />

                {/* Checkbox controlado para indicar si debe incluirse un plan de acción */}
                <div className="form-check mt-3">
                    <input
                        className="form-check-input"
                        type="checkbox"
                        checked={includeActionPlan}
                        onChange={(e) => setIncludeActionPlan(e.target.checked)}
                    />
                    <label className="form-check-label">
                        Debe Incluir Plan de Acción
                    </label>
                </div>
            </Modal.Body>

            <Modal.Footer>
                {/* Botón de cancelar: cierra el modal sin llamar al callback */}
                <Button
                    variant="secondary"
                    className="rounded-pill"
                    onClick={() => setShowFormModal(false)}
                >
                    Cancelar
                </Button>

                {/* Botón de enviar: ejecuta el manejador que llama al callback del padre */}
                <Button
                    variant="primary"
                    className="rounded-pill"
                    onClick={handleReject}
                >
                    Enviar
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default SecondPeriodRejectObjectivesModal;